var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper",staticStyle:{"height":"auto","min-height":"100%"}},[_c('the-header'),_c('div',{staticClass:"content-wrapper content-wrapper2",attrs:{"id":"content-wrap"}},[_c('section',{staticClass:"contant"},[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1)],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }